module.exports = __webpack_public_path__ + "static/img/bgscreenimg6.80ee6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscreenimg6.png
// module id = G0Xd
// module chunks = 5